// auth constants
module.exports.sessionLocalStorageKey = "ss-flex-session";
module.exports.repNameStorageKey = "ss-flex-rep-name";
module.exports.repAccountIdStorageKey = "ss-flex-rep-account-id";
module.exports.cartCacheKey = "@ss-flex-cart-cache";
module.exports.infoFieldsStorageKey = "@ss-flex-info-fields";
module.exports.languageSelectionStorageKey = "@ss-flex-locale";

module.exports.inventoryTypeUIDs = {
  seatLevel: "SEAT-LEVEL",
  seatLevelMulti: "SEAT-LEVEL-MULTI",
  sectionLevel: "SECTION-LEVEL",
  suitLevel: "SUITE-LEVEL",
  suiteLevelV2: "SUITE-LEVEL-V2",
  groupLevel: "GROUP-LEVEL",
  ada: "ADA",
};

// filter panel names
module.exports.filterPanelNames = {
  opponent_selector: "opponent_selector",
  date_range_selector: "date_range_selector",
  seat_counter: "seat_counter",
  dynamic_seat_count: "dynamic_seat_count",
  price_selector: "price_selector",
  accessibility_selector: "accessibility_selector",
  section_selector: "section_selector",
  category_selector: "category_selector",
};

module.exports.authUIDs = {
  tmAuth: "tmAuth",
  register: "register",
  login: "login",
  forgotPassword: "forgot_password",
  resetPassword: "reset_password",
};

// gift card constants
module.exports.giftCardUIDs = {
  redeem: "redeem_gift_card",
  redeemSucess: "redeem_gift_card_sucess",
  createGiftCard: "create_gift_card",
  checkout: "checkout_gift_card",
  checkoutSucess: "checkout_gift_card_sucess",
};

// add credit contants
module.exports.addCreditsUIDs = {
  createAddCredit: "create_add_credit",
  checkout: "checkout_add_credit",
  checkoutSucess: "checkout_add_credit_sucess",
};

// purchase seat constants
module.exports.purchaseSeatsTabUIDs = {
  packages: "packages",
  findGames: "find_games",
  chooseSeats: "choose_seats",
  selectPerks: "select_perks",
  checkout: "purchase_seat_checkout",
};

// auth origins uids
module.exports.authOriginUIDs = {
  purchaseSeats: "purchaseSeats",
  purchaseCredit: "purchaseCredit",
  giftCardStandalone: "giftCardStandalone",
  giftCardRedeemStandalone: "giftCardRedeemStandalone",
  purchaseGift: "purchaseGiftCard",
  redeemGift: "redeemGift",
  loginPage: "loginPage",
  generalAuth: "generalAuth",
  ticketTransferPage: "ticketTransferPage",
  linkTicketTransfer: "linkTicketTransfer",
  previewInventory: "previewInventory",
};

// vendor uuids
module.exports.vendorUUIDs = {
  ticketmaster: "TM",
  tickesdotcom: "TDC",
};

// custom dom events
module.exports.customEvents = {
  eventPurchaseSuccess: "eventPurchaseSuccess",
  giftPurchaseSuccess: "giftPurchaseSuccess",
  sessionUnauthorized: "sessionUnauthorized",
  authCompleted: "authCompleted",
  openGameFilter: "openGameFilter",
};

module.exports.dateFormats = [
  "MM-dd-yyyy",
  "MM/dd/yyyy",
  "yyyy-MM-dd",
  "yyyy/MM/dd",
  "MM-dd-yyyy",
  "MM/dd/yyyy",
  "yyyy-MM-dd",
  "yyyy/MM/dd",
  "MM-dd-yy",
  "MM/dd/yy",
  "yy-MM-dd",
  "yy/MM/dd",
  "MM-dd-yy",
  "MM/dd/yy",
  "yy-MM-dd",
  "yy/MM/dd",
];

module.exports.locales = {
  en: "en",
  fr: "fr",
};

module.exports.localesValuesMap = {
  en: "English",
  fr: "Français",
};

module.exports.constants = {
  ...module.exports,
};
